import { render } from "./DebugFragenblock.vue?vue&type=template&id=1367659e&ts=true"
import script from "./DebugFragenblock.vue?vue&type=script&lang=ts"
export * from "./DebugFragenblock.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__